if (!customElements.get('product-layout')) {
  class ProductLayout extends HTMLElement {
    constructor() {
      super();
  
      this.image = this.querySelector('.product-layout-image');
      this.links = this.querySelectorAll('a');
      this.hiddenVariants = this.querySelectorAll('.product-layout-variant.product-layout-variant-hidden');
  
      this.querySelectorAll('.product-layout-variant')?.forEach(el => el?.addEventListener('click', this.onVariantClick.bind(this)));
      this.querySelector('.product-layout-show-all')?.addEventListener('click', this.showAll.bind(this));
    }
  
    onVariantClick (event) {
      event.preventDefault();
      const target = event.currentTarget;
      if (target) {
        const imageUrl = target.dataset.imageUrl;
        const variantUrl = target.dataset.variantUrl;
        if (imageUrl) this.image.src = imageUrl;
        if (variantUrl) {
          this.links.forEach(el => {
            el.href = variantUrl;
          });
        }
      }
    }
  
    showAll (event) {
      event.preventDefault();
      this.hiddenVariants.forEach(el => el.classList.remove('product-layout-variant-hidden'));
      event.currentTarget.remove();
    }
  }
  
  window.customElements.define('product-layout', ProductLayout);
}
